import styles from './index.module.scss'
import { Checkbox, message } from 'antd'
import Utils from '@utils/utils'
import Iconfont from '@utils/Iconfont'
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons'
import PSAIModal from '@PSAIComponents/PSAIModal'
import { useNavigate } from 'react-router-dom'
import API, { commonApiInvoker } from '@api/api.js'
import { throttle } from 'lodash'
import { useMemo, useState } from 'react'
import { IMAGE_TYPE, TYPETITLEMAP } from '@utils/CONST'
import { useContext } from 'react'
import { AppContext } from '@utils/AppContext'

const ProjectListItem = (props) => {
    const navigate = useNavigate()
    const { isSelected, item, selectedList } = props
    const [downLoading, setDownLoading] = useState(false)
    const { proSidebarValue } = useContext(AppContext)

    const deleteClick = () => {
        PSAIModal.confirm({
            title: '删除项目',
            content: '删除后项目将无法找回，确定删除吗？',
            onOk: deleteProject,
        })
    }

    const deleteProject = () => {
        commonApiInvoker(API.deleteProject({
            projectId: item?.id,
        })).then(() => {
            message.success('删除成功！')
            props.listProjectv2()
        })
    }

    const projectBatchDownloadMeta = () => {
        projectBatchDownload()
    }

    const projectBatchDownload = throttle(() => {
        setDownLoading(true)
        commonApiInvoker(API.projectPatchDownload({
            ids: [item?.id],
        }), setDownLoading).then((res) => {
            Utils.downloadFileWithToken(res).then(() => {
                message.success('下载成功')
            }).catch(() => {
                message.warning('下载失败，请稍后重试')
            }).finally(() => {
                setDownLoading(false)
            })
        })
    }, 1000)

    const isCollect = useMemo(() => {
        return item?.id === 'collect'
    }, [item])

    const isVideo = useMemo(() => {
        return IMAGE_TYPE.MODEL_VIDEO == item?.imageType || IMAGE_TYPE.IMAGE_TO_VIDEO == item?.imageType
    }, [item])

    const previewImage = item?.mainImage?.split(',')[0]
    const hasPreviewImage = !!previewImage

    const typeTitle = TYPETITLEMAP[item?.imageType] || ''
    const titleLine = typeTitle ? `${typeTitle} | ${item?.projectName || ''}` : (item?.projectName || '')
    const creatorText = (item.memberName && item.orgData) ? `${item.memberName}` : ''

    return (
        <div className={styles.ProjectListItem}>
            <div
                className={styles.imgBox}
                onClick={() => navigate(`/home/myProject/${item.id}/detail${item?.id === 'collect' ? `?module=${encodeURIComponent(proSidebarValue)}` : ''}`)}
            >
                {hasPreviewImage ? (
                    <img src={Utils.getImgThumbnail(previewImage)} alt="" />
                ) : (
                    <div className={styles.EmptyPreview}>
                        <Iconfont type="icon-genimageOutlined" className={styles.EmptyPreviewIcon} />
                    </div>
                )}
                {!isCollect && <div className={styles.hoverMask}>查看合集</div>}
                {isVideo && <i className={styles.VideoIcon}></i>}
                {item.allFailed && (
                    <div className={styles.failMask}>
                        <Iconfont className={styles.iconfont} type="icon-imageErrorOutline" />
                        <p>生成失败</p>
                    </div>
                )}
            </div>
            <p className={styles.proTitleBox} title={titleLine}>{titleLine}</p>
            {!isCollect && (
                <div className={styles.metaRow}>
                    <p className={styles.creatDate}>
                        <span>{item.updatedTime.split(' ')[0]}</span>
                        {creatorText && <span className={styles.creatorText}>{creatorText}</span>}
                    </p>
                    <span className={styles.options}>
                        {downLoading ? (
                            <LoadingOutlined className={styles.Icon} />
                        ) : (
                            <DownloadOutlined className={styles.Icon} onClick={projectBatchDownloadMeta} />
                        )}
                        <Iconfont type="icon-DeleteOutlined" className={styles.Icon} onClick={deleteClick} />
                    </span>
                </div>
            )}
            {isSelected && (
                <div className={styles.SelectMask} onClick={() => props.selectCurrentItem(item?.id)}>
                    <Checkbox
                        className={styles.ItemSelect}
                        checked={selectedList.includes(item?.id)}
                    />
                </div>
            )}
        </div>
    )
}

export default ProjectListItem
